import { Component, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor,NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-string-selector',
  templateUrl: './string-selector.component.html',
  styleUrls: ['./string-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: StringSelectorComponent,
      multi: true
    }
  ]
})
export class StringSelectorComponent implements OnInit,ControlValueAccessor {
  @Input() strings:string[] = [];
  @Input() multiple:boolean = false;
  @Input() translate:(string:string,trig?:boolean)=>{} = (string:string)=> string;
  private _value:string;
  private _choices:string[];
  disabled:boolean = false;
  onChange = (value:string|string[])=> {};
  onTouch = ()=>{};
  get value():string|string[]{
    return this.multiple ? this._choices : this._value;
  }
  @Input() set value( value:string|string[]){
      
      this.writeValue( value );
  }
  @Output() selectionChange:Subject<any> = new Subject<any>();
  constructor() { }
  toggleAll(){
    if( this.multiple ){
      if(this._choices.length > 0){
        this.writeValue( [] );
      }else{
        this.writeValue([...this.strings]);
      }
    }
  }
  toggleValue( value:string ){
    if( this.multiple ){
      const choices = [...this._choices];
      if( choices.includes( value )){
        choices.splice( choices.indexOf(value), 1 );
      }else{
        choices.push( value );
      }
      this.writeValue( choices );
    }else{
      let current = this._value;
      if(current == value){
        current=null;
      }else{
        current=value;
      }
      this.writeValue( current );
    }
    this.onTouch();
  }
  isValueSelected( value:string ){
    if( this.multiple ){
      return this._choices.includes( value );
    }else{
      return this._value == value;
    }
  }

  isSelectedColor( value:string){
    return this.isValueSelected(value) ? 'primary' : 'medium';
  }
  writeValue(value:string|string[]): void {
    this.onChange( value );
    console.log('writeValue',value)
    if(this.multiple){
      this._choices = value as string[];
      this.selectionChange.next( [...this._choices] );
    }else{
      this._value = value as string;
      this.selectionChange.next( this._value );
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit() {}

}
